import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

import { useFormContext } from '../../contexts';

export function SubmitButton({ variant = 'primary', isDisabled, ...props }: ButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe
      selector={(state) => ({
        isSubmitting: state.isSubmitting,
        isValid: state.isValid,
        isDirty: state.isDirty,
        canSubmit: state.canSubmit,
      })}
    >
      {({ isSubmitting, isValid, isDirty, canSubmit }) => (
        <Button
          isDisabled={isSubmitting || !isValid || !isDirty || !canSubmit || isDisabled}
          isPending={isSubmitting}
          onPress={() => form.handleSubmit()}
          variant={variant}
          {...props}
          data-test-id="submit-button"
        >
          {props.children}
        </Button>
      )}
    </form.Subscribe>
  );
}
